<template>
  <div>
    <b-table
      :fields="fields"
      :items="fieldMap"
      stacked="md"
    >
      <template v-slot:cell(sampleValue)="data">
        <!-- Sample value -->
        {{ csvRow.data[data.item.column] }}
      </template>

      <template v-slot:cell(name)="data">
        <!-- Column Name Input -->
        <b-input
          v-model="data.item.name"
          type="text"
        />
      </template>

      <template v-slot:cell(type)="data">
        <!-- Type Input -->
        <UpdateFieldType :field="data.item" />
      </template>

      <template v-slot:cell(unit)="data">
        <!-- Unit Input -->
        <UpdateFieldUnit
          v-if="data.item.type === MONETARY || data.item.type === NUMERIC"
          :field="data.item"
          style="width: 5em;"
        />
      </template>

      <template v-slot:cell(total)="data">
        <!-- Total Checkbox -->
        <UpdateFieldMapTotal
          v-if="data.item.type === MONETARY || data.item.type === NUMERIC"
          :field="data.item"
        />
      </template>
    </b-table>
  </div>
</template>

<script lang="ts">

import Vue, { PropType } from 'vue'
import Component from 'vue-class-component'

import { FieldCalculationV2Config, FieldMapItem, FieldTypes } from '@/types'
import UpdateFieldType from '@/components/builder/FieldSettings/UpdateFieldType.vue'
import UpdateFieldUnit from '@/components/builder/FieldSettings/UpdateFieldUnit.vue'
import UpdateFieldMapTotal from '@/components/builder/FieldSettings/UpdateFieldMapTotal.vue'

const components = {
  UpdateFieldType,
  UpdateFieldUnit,
  UpdateFieldMapTotal,
}

const props = {
  fieldMap: {
    type: Array as PropType<(FieldMapItem | FieldCalculationV2Config)[]>,
    required: true,
  },
}

@Component({ components })
export default class DefineFields extends Vue.extend({ props }) {
  MONETARY = FieldTypes.MONETARY
  NUMERIC = FieldTypes.NUMERIC
  fields = [
    { key: 'column', label: 'CSV Column' },
    { key: 'sampleValue', label: 'Sample Value' },
    { key: 'name' },
    { key: 'type' },
    { key: 'unit' },
    { key: 'total' },
  ]

  get leafDataForRoot () {
    return this.$typedStore.visualisationData.leafDataForRoot
  }

  get csvRow () {
    return this.leafDataForRoot[0]
  }
}

</script>
